// extracted by mini-css-extract-plugin
export var checkboxInputRow = "w_sr";
export var checkboxInputColumn = "w_ss";
export var inputOptionRow = "w_qq";
export var inputOptionColumn = "w_qr";